import { Icon } from 'src/general/Icons/Icon';
import { FilterName } from 'src/plp/components/FilterName/FilterName';

import { FilterHierarchyFieldsGroupOption, PlpHierarchyFilterItemProps } from '../PlpFilters.type';
import { FilterAccordion } from '../components/FilterAccordion/FilterAccordion';
import { PlpFiltersMake } from '../components/PlpFiltersMake/PlpFiltersMake';

type Props = PlpHierarchyFilterItemProps<FilterHierarchyFieldsGroupOption>;

export const FilterMakeModel = ({ options, currentFilters, index, showNotificationBadge, ...props }: Props) => {
  const id = 'makeModel';
  const header = (
    <FilterName icon={<Icon name="make-model" />} label="Make & Model" showNotificationBadge={showNotificationBadge} />
  );
  const content = (
    <PlpFiltersMake options={options} subCategoryLabel="Model" currentFilters={currentFilters} {...props} />
  );

  return <FilterAccordion id={id} header={header} content={content} index={index} />;
};
